import api from '../api';

import { experienceApiRoutes } from './const';

export type IssueTrustedDeviceResponse = {
  expiresAt: number;
};

export const issueTrustedDevice = async () =>
  api.post(experienceApiRoutes.trustedDevice).json<IssueTrustedDeviceResponse>();

export type VerifyTrustedDeviceResponse = {
  valid: boolean;
};

export const verifyTrustedDevice = async (encryptedUserId: string) =>
  api
    .post(`${experienceApiRoutes.trustedDevice}/verify`, {
      json: { userId: encryptedUserId },
    })
    .json<VerifyTrustedDeviceResponse>();
